<template>
    <div class="back relative w-6 h-6 text-center cursor-pointer"
         :class="isDisable ? 'text-black bg-tc-gray-4' : 'text-white bg-tc-blue-1'"
         @click="onclick()">
        <div class="back-icon absolute">
            <img src="@/assets/icon/back.svg" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Backbtn',
    props:{
        isDisable:{
            type: Boolean,
            default: true
        }
    },
    data: function(){
        return{

        }
    },
    methods:{
        onclick: function(){
            this.$emit('onClick');
        }
    }
};
</script>

<style lang="scss" scoped>
.back{
    border-radius: 50%;
}
.back-icon{
    top: 7px;
    left: 8px;
}
</style>
